import React from 'react';
import DisclaimerMessageUtil from './DisclaimerMessageUtil';

export default function PerUnitDisclaimer(props) {
    const { handleClosePerUnitDisclaimer } = props;
    const dataTestID = 'perUnit';
    const messageKey = 'Note';
    const messageValue = 'Your provider may order multiples, which can increase the cost estimate.';
    const isWarningDisclaimer = false;
    return (
        <DisclaimerMessageUtil
            handleCloseIconClick={handleClosePerUnitDisclaimer}
            messageKey={messageKey}
            messageValue={messageValue}
            dataTestID={dataTestID}
            isWarningDisclaimer={isWarningDisclaimer}
        />
    );
}
